import './reset.css';
import './style.css';
import {useEffect} from "react";
import {
    getAppData,
    getAuthRequest,
    getCategoriesRequest,
    getConfigRequest, getPagesRequest, getSearchRequest,
    hideLoader,
    showLoader
} from "./redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {LoadingPage} from "./components/LoadingPage";
import {ErrorDataPage} from "./components/ErrorDataPage";
import React from 'react';
import {Cards} from "./components/Cards";
import {Info} from "./components/Info";
import {Search} from "./components/Search";
import {Header} from "./components/Header";
import {Categoriesfilter} from "./components/Categoriesfilter";
import {useParams} from "react-router-dom";
import {Footer} from "./components/Footer";
import {ResetFilter} from "./components/ResetFilter";
import {useStickyBox} from "react-sticky-box";
import {Filters} from "./components/Filters";
import {Text} from "./components/Text";


function App() {
    const dispatch = useDispatch()
    const isLoading = useSelector(state => state.app.isLoading)
    const isError = useSelector(state => state.app.isError)
    const pagesRequest = useSelector(state => state.app.pagesRequest)
    const categoriesRequest = useSelector(state => state.app.categoriesRequest)
    const configRequest = useSelector(state => state.app.configRequest)
    const authRequest = useSelector(state => state.app.authRequest)
    const dataRequest = useSelector(state => state.app.dataRequest)
    const searchRequest = useSelector(state => state.app.searchRequest)
    const current_page = useSelector(state => state.app.current_page)
    const isMobile = useSelector(state => state.app.isMobile)
    const current_category = useSelector(state => state.app.current_category)
    let {category} = useParams();

    if (category === undefined) {
        category = '';
    }
    const stickyRef = useStickyBox({offsetTop: 20, offsetBottom: 20})

    const handleWindowSizeChange = () => {
        if (window.innerWidth <= 1100 && !isMobile) {
            window.location.reload()
        }
        if (window.innerWidth > 1100 && isMobile) {
            window.location.reload()
        }
    }


    useEffect(() => {

        if (pagesRequest === false) {
            dispatch(showLoader())
            dispatch(getPagesRequest(category));
        } else {
            if (categoriesRequest === false) {
                dispatch(getCategoriesRequest(category, current_page));
            } else {
                if (configRequest === false) {
                    dispatch(getConfigRequest());
                } else {
                    if (authRequest === false) {
                        dispatch(getAuthRequest());
                    } else {
                        if (dataRequest === false) {
                            dispatch(getAppData(category))
                        } else {
                            if (searchRequest === false) {
                                dispatch(getSearchRequest());
                            }
                            dispatch(hideLoader());
                        }
                    }
                }
            }
        }

    }, [dispatch, categoriesRequest, configRequest, authRequest, dataRequest, category, searchRequest, pagesRequest,current_page]);

    useEffect(() => {
        const canonicalUrl = window.location.origin + window.location.pathname;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', canonicalUrl);
    }, [category, current_category]);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    });

    if (isLoading || 1 === 2) {
        return (<LoadingPage/>)
    }
    if (isError) {

        return (
            <section className="container">
                <div className="container__wrap">
                    <ErrorDataPage/>
                </div>
            </section>
        )
    }
    if (isMobile) {
        return (
            <React.Fragment>
                <Header/>
                <section className="container">
                    <div className="container__wrap">
                        <Info/>
                        <Search/>
                        <Categoriesfilter/>
                        <Filters/>

                        <Cards/>
                        <Text/>
                    </div>
                </section>
                <Footer/>
            </React.Fragment>

        );
    }
    return (
        <React.Fragment>
            <Header/>
            <section className="container app-box">
                <div className="container__sidebar_wrap" ref={stickyRef}>
                    <Filters/>
                    <Categoriesfilter/>
                    <ResetFilter/>
                </div>
                <div className="container__content_wrap">
                    <div className="content-box">
                        <Info/>
                        <Search/>
                        <Cards/>
                        <Text/>
                    </div>

                </div>
            </section>
            <Footer/>
        </React.Fragment>

    );
}

export default App;
